import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import DraggableHeaderCell from './DraggableHeaderCell';
import HeaderCell from './HeaderCell';
import HeaderRowWrapper from './HeaderRowWrapper';
import { IColumn, ISortChange } from '../interfaces';

interface IProps {
  columns: IColumn[],
  sortBy?: string,
  sortOrder?: string,
  onSortChange?: ISortChange,
}

const DraggableHeaderRow = ({
  columns,
  sortBy,
  sortOrder,
  onSortChange,
}: IProps) => (
  <SortableContext
    items={ columns.filter((col) => col.isDraggable !== false).map((col) => col.name) }
    strategy={ horizontalListSortingStrategy }
  >
    <HeaderRowWrapper>
      { columns.map(({ CustomHeadCell, ...column }) => {
        const CellComponent = column.isDraggable === false ? HeaderCell : DraggableHeaderCell;

        return CustomHeadCell ? (
          <CustomHeadCell
            sortBy={ sortBy }
            sortOrder={ sortOrder }
            onSortChange={ onSortChange }
            key={ column.name }
            { ...column }
          />
        ) : (
          <CellComponent
            sortBy={ sortBy }
            sortOrder={ sortOrder }
            onSortChange={ onSortChange }
            key={ column.name }
            { ...column }
          />
        );
      }) }
    </HeaderRowWrapper>
  </SortableContext>
);

export default DraggableHeaderRow;
